import { clsx } from 'clsx';
import { Avatar } from '@nula/core-ui';
import { useCardDrift } from '../../hooks/use-card-drift';
import styles from './editor-card.module.css';

/** Floating editor product card for the onboarding constellation. */
export function EditorCard() {
  const ref = useCardDrift({ amp: 7, speed: 0.10, phase: 0 });

  return (
    <div
      ref={ref as React.RefObject<HTMLDivElement>}
      className={styles.card}
    >
      {/* Card chrome */}
      <div className={styles.cardhead}>
        <span className={styles.label}>Editor</span>
        <span className={styles.windowDots}>
          <span className={styles.windowDot} />
          <span className={styles.windowDot} />
          <span className={styles.windowDot} />
        </span>
      </div>

      {/* Card body */}
      <div className={styles.cardbody}>
        <div className={styles.titlerow}>
          <span className={styles.docTitle}>Product strategy</span>
          <Avatar.Group size={16}>
            <Avatar shape="circle" className={clsx(styles.avatarBlob, styles.avatarPrimary)} />
            <Avatar shape="circle" className={clsx(styles.avatarBlob, styles.avatarGreen)} />
            <Avatar shape="circle" className={clsx(styles.avatarBlob, styles.avatarAmber)} />
          </Avatar.Group>
        </div>

        {/* Text lines (doc body preview) */}
        <div className={clsx(styles.textLine, styles.textLineW100)} />
        <div className={clsx(styles.textLine, styles.textLineW88)} />
        <div className={clsx(styles.textLine, styles.textLineHighlight, styles.textLineW54)} />
        <div className={clsx(styles.textLine, styles.textLineW74)} />

        {/* Live collaborator cursor */}
        <span className={styles.cursor} aria-hidden>
          <svg className={styles.cursorIcon} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
            <path d="M5 3l14 7-6 2-2 6z" />
          </svg>
          <span className={styles.cursorTag}>Theo</span>
        </span>
      </div>
    </div>
  );
}
